define(["exports", "react", "styled-components", "react-intl-universal", "../../atoms"], function (_exports, _react, _styledComponents, _reactIntlUniversal, _atoms) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);

  var ItemSalary = _styledComponents.default.div.withConfig({
    displayName: "Salary__ItemSalary",
    componentId: "sc-11cxba7-0"
  })(["h2{margin:0 0 16px;}h3{margin:0;}p{margin:0;}p + h3{margin:18px 0 0;}"]);

  var Salary = function Salary(_ref) {
    var _currentSalary$valor, _intendedSalary$valor;

    var benefits = _ref.benefits,
        currentSalary = _ref.currentSalary,
        intendedSalary = _ref.intendedSalary;

    var currentLocale = _reactIntlUniversal.default.getInitOptions().currentLocale;

    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(ItemSalary, null, /*#__PURE__*/_react.default.createElement(_atoms.H2, null, _reactIntlUniversal.default.get('CURRICULUM.REMUNERACAO.TITULO')), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: benefits
    }, /*#__PURE__*/_react.default.createElement(_atoms.H3, null, _reactIntlUniversal.default.get('CURRICULUM.REMUNERACAO.BENEFICIOS')), /*#__PURE__*/_react.default.createElement(_atoms.Small, null, benefits)), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: (currentSalary == null ? void 0 : currentSalary.valor) && (currentSalary == null ? void 0 : currentSalary.moeda) || (intendedSalary == null ? void 0 : intendedSalary.valor) && (intendedSalary == null ? void 0 : intendedSalary.moeda)
    }, !!(currentSalary != null && currentSalary.valor) && (currentSalary == null ? void 0 : currentSalary.valor) !== 0 || !!(intendedSalary != null && intendedSalary.valor) && (intendedSalary == null ? void 0 : intendedSalary.valor) !== 0 ? /*#__PURE__*/_react.default.createElement(_atoms.H3, null, _reactIntlUniversal.default.get('CURRICULUM.REMUNERACAO.SALARIO')) : null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: (currentSalary == null ? void 0 : currentSalary.valor) && (currentSalary == null ? void 0 : currentSalary.moeda)
    }, !!(currentSalary != null && currentSalary.valor) && (currentSalary == null ? void 0 : currentSalary.valor) !== 0 ? /*#__PURE__*/_react.default.createElement(_atoms.Small, null, _reactIntlUniversal.default.get('CURRICULUM.REMUNERACAO.ULTIMO'), !!currentSalary && (currentSalary == null ? void 0 : (_currentSalary$valor = currentSalary.valor) == null ? void 0 : _currentSalary$valor.toLocaleString(currentLocale, {
      style: 'currency',
      currency: currentSalary == null ? void 0 : currentSalary.moeda
    }))) : null), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: (intendedSalary == null ? void 0 : intendedSalary.valor) && (intendedSalary == null ? void 0 : intendedSalary.moeda)
    }, !!(intendedSalary != null && intendedSalary.valor) && (intendedSalary == null ? void 0 : intendedSalary.valor) !== 0 ? /*#__PURE__*/_react.default.createElement(_atoms.Small, null, _reactIntlUniversal.default.get('CURRICULUM.REMUNERACAO.PRETENDIDO'), !!intendedSalary && (intendedSalary == null ? void 0 : (_intendedSalary$valor = intendedSalary.valor) == null ? void 0 : _intendedSalary$valor.toLocaleString(currentLocale, {
      style: 'currency',
      currency: intendedSalary == null ? void 0 : intendedSalary.moeda
    }))) : null))));
  };

  Salary.defaultProps = {
    benefits: ''
  };
  var _default = Salary;
  _exports.default = _default;
});